/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['nav[_ngcontent-%COMP%]{border:0;margin-bottom:0;border-radius:0;display:flex;flex-wrap:wrap;align-items:center;padding:12px 24px;background-color:#1c1c1c;border-bottom:1px solid hsla(0,0%,100%,.1)}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3NoYXJlZC9uYXZiYXIvbmF2YmFyLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3NoYXJlZC9uYXZiYXIvbmF2YmFyLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/shared/navbar/navbar.component.scss.shim.ngstyle.ts